import script from "./ServicePackageDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServicePackageDetails.vue?vue&type=script&lang=ts&setup=true"

import "./ServicePackageDetails.vue?vue&type=style&index=0&id=b30a254a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b30a254a"]])

export default __exports__